export default "__VITE_ASSET__04423ab0__"